import { render, staticRenderFns } from "./receiveDetails.vue?vue&type=template&id=e0444e5e&scoped=true&"
import script from "./receiveDetails.vue?vue&type=script&lang=js&"
export * from "./receiveDetails.vue?vue&type=script&lang=js&"
import style0 from "./receiveDetails.vue?vue&type=style&index=0&id=e0444e5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0444e5e",
  null
  
)

export default component.exports